import {
  ArrowLeft,
  Building2,
  CheckCircle2,
  Files,
  Image,
  Landmark,
  LayoutPanelTop,
  Library,
  MessageSquare,
  ScanQrCode,
  Settings2,
  ShieldCheck,
  Sparkles,
} from 'lucide-react';
import { Link } from 'react-router-dom';

const features = [
  { icon: MessageSquare, title: 'المساعد العام', text: 'محادثات متعددة وسياق مؤسسي ومعرفة موثوقة.' },
  { icon: Landmark, title: 'العمارة المحلية', text: 'تطوير الواجهات وفق دستور معماري قابل للإدارة.' },
  { icon: LayoutPanelTop, title: 'إخراج المخططات', text: 'لوحات تقديم وأغلفة وحزم PDF قابلة للتتبع.' },
  { icon: Files, title: 'تجهيز المخططات', text: 'معالجة محلية أولًا وJobs واضحة قابلة للمتابعة.' },
  { icon: Library, title: 'المعرفة المؤسسية', text: 'أوامر عربية ومكتبة Prompts محفوظة داخل Details.' },
  { icon: ScanQrCode, title: 'التحقق والأرشيف', text: 'بصمات ومراجع وسجل إصدارات لكل مخرج مهم.' },
];

const modes = [
  { icon: Image, label: 'الاستوديو العام' },
  { icon: Building2, label: 'العمارة المحلية' },
  { icon: Sparkles, label: 'المخططات التخصصية' },
  { icon: Settings2, label: 'الإدارة والمزودون' },
];

export function LandingPage() {
  return (
    <main className="relative min-h-screen overflow-hidden bg-sand">
      <div className="pattern absolute inset-0 opacity-70" />
      <div className="absolute -left-40 top-16 h-96 w-96 rounded-full bg-teal/10 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 pb-16 pt-6 sm:px-8">
        <nav className="glass flex items-center justify-between rounded-2xl px-4 py-3 shadow-sm sm:px-6">
          <div className="flex items-center gap-3">
            <div className="grid h-11 w-11 place-items-center rounded-xl bg-ink text-lg font-black text-white">
              د
            </div>
            <div>
              <p className="text-sm font-black tracking-wide text-ink">DETAILS AI</p>
              <p className="text-[11px] font-bold text-slate-500">منصة الذكاء الهندسي</p>
            </div>
          </div>
          <Link
            to="/admin/login"
            className="inline-flex items-center gap-2 rounded-xl bg-ink px-5 py-2.5 text-sm font-bold text-white shadow-lg shadow-ink/15 transition hover:-translate-y-0.5 hover:bg-teal"
          >
            <ShieldCheck className="h-4 w-4" />
            دخول المشرف
          </Link>
        </nav>

        <section className="grid items-center gap-12 pb-20 pt-20 lg:grid-cols-[1.1fr_0.9fr] lg:pt-28">
          <div>
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-teal/20 bg-white/70 px-4 py-2 text-xs font-bold text-teal">
              <span className="h-2 w-2 rounded-full bg-teal" />
              مساحة عمل واحدة للمعرفة والتصميم والإخراج
            </div>
            <h1 className="max-w-3xl text-4xl font-black leading-[1.25] text-ink sm:text-6xl sm:leading-[1.2]">
              ذكاء اصطناعي
              <span className="relative mx-3 inline-block text-teal">
                يفهم التفاصيل
                <span className="absolute -bottom-2 right-0 h-1.5 w-full rounded-full bg-gold/70" />
              </span>
              لا يخمّنها.
            </h1>
            <p className="mt-7 max-w-2xl text-base font-semibold leading-8 text-slate-600 sm:text-lg">
              منصة تجمع المساعد الذكي، الاستوديوهات المعمارية، مكتبة الأوامر،
              معالجة الملفات، وسجل النتائج في منظومة عربية واحدة تحفظ المعرفة
              داخل Details.
            </p>
            <div className="mt-9 flex flex-wrap gap-3">
              <Link
                to="/admin/login"
                className="inline-flex items-center gap-2 rounded-xl bg-teal px-6 py-3 text-sm font-black text-white shadow-xl shadow-teal/20 transition hover:-translate-y-0.5 hover:bg-ink"
              >
                دخول المشرف
                <ArrowLeft className="h-4 w-4" />
              </Link>
              <a
                href="#features"
                className="inline-flex items-center gap-2 rounded-xl border border-ink/15 bg-white/70 px-6 py-3 text-sm font-bold text-ink transition hover:border-teal/40 hover:bg-white"
              >
                استكشف المنصة
              </a>
            </div>
            <div className="mt-9 flex flex-wrap gap-x-6 gap-y-3 text-xs font-bold text-slate-600">
              {['معالجة محلية أولًا', 'مزودون قابلون للاستبدال', 'صلاحيات وسجل تدقيق'].map(
                (item) => (
                  <span key={item} className="inline-flex items-center gap-2">
                    <CheckCircle2 className="h-4 w-4 text-teal" />
                    {item}
                  </span>
                ),
              )}
            </div>
          </div>

          <div className="relative">
            <div className="absolute -inset-8 rounded-full bg-teal/10 blur-3xl" />
            <div className="glass relative rounded-[2rem] p-5 shadow-panel sm:p-7">
              <div className="mb-5 flex items-center justify-between">
                <div>
                  <p className="text-[11px] font-bold text-slate-500">مساحة العمل</p>
                  <p className="text-lg font-black text-ink">لوحة المنصة</p>
                </div>
                <div className="flex gap-1.5">
                  <span className="h-2.5 w-2.5 rounded-full bg-red-300" />
                  <span className="h-2.5 w-2.5 rounded-full bg-amber-300" />
                  <span className="h-2.5 w-2.5 rounded-full bg-emerald-300" />
                </div>
              </div>
              <div className="space-y-3 rounded-2xl bg-ink p-4 text-white sm:p-5">
                <div className="flex items-center gap-3 rounded-xl bg-white/10 p-3">
                  <div className="grid h-9 w-9 place-items-center rounded-lg bg-teal">
                    <MessageSquare className="h-4 w-4" />
                  </div>
                  <div className="flex-1">
                    <p className="text-xs font-black">مساعد المشروع</p>
                    <p className="mt-1 text-[10px] text-white/55">سياق المشروع والمعرفة المحلية</p>
                  </div>
                  <span className="rounded-full bg-emerald-400/20 px-2 py-1 text-[9px] font-bold text-emerald-200">
                    جاهز
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {modes.map(({ icon: Icon, label }) => (
                    <div key={label} className="rounded-xl border border-white/10 bg-white/[0.06] p-3">
                      <Icon className="mb-3 h-5 w-5 text-gold" />
                      <p className="text-[11px] font-bold">{label}</p>
                      <div className="mt-3 h-1 rounded-full bg-white/10">
                        <div className="h-1 w-2/3 rounded-full bg-teal" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-4 grid grid-cols-3 gap-2">
                {[
                  ['14', 'محادثة'],
                  ['36', 'أمر جاهز'],
                  ['10', 'أوضاع'],
                ].map(([value, label]) => (
                  <div key={label} className="rounded-xl border border-ink/10 bg-white p-3 text-center">
                    <strong className="block text-xl text-ink">{value}</strong>
                    <span className="text-[10px] font-bold text-slate-500">{label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section id="features" className="scroll-mt-8">
          <div className="mb-8 flex items-end justify-between gap-4">
            <div>
              <p className="text-xs font-black text-teal">منظومة واحدة</p>
              <h2 className="mt-2 text-2xl font-black text-ink sm:text-3xl">من الفكرة إلى المخرج الموثّق</h2>
            </div>
            <p className="hidden max-w-md text-sm leading-6 text-slate-500 md:block">
              كل نتيجة ترتبط بسياقها وملفاتها وإصدار الأوامر والمزود المستخدم.
            </p>
          </div>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {features.map(({ icon: Icon, title, text }) => (
              <article
                key={title}
                className="group rounded-2xl border border-ink/10 bg-white/75 p-5 transition hover:-translate-y-1 hover:border-teal/30 hover:shadow-panel"
              >
                <div className="mb-4 grid h-11 w-11 place-items-center rounded-xl bg-teal/10 text-teal transition group-hover:bg-teal group-hover:text-white">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="text-sm font-black text-ink">{title}</h3>
                <p className="mt-2 text-xs font-semibold leading-6 text-slate-500">{text}</p>
              </article>
            ))}
          </div>
        </section>

        <footer className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-ink/10 pt-6 text-xs font-bold text-slate-500">
          <span>Details AI Platform · مساحة ذكاء هندسي خاصة</span>
          <span>details-ai.cloud</span>
        </footer>
      </div>
    </main>
  );
}
